import { nbVal } from "@paroi/data-formatters-lib";
import { useWrapAsync } from "@paroicms/front-app-log";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchOneReference } from "../../../../api/application/reference";
import { useAppStore } from "../../../../store/app.store";
import { useGetDatabaseCreationInfo } from "../../../../store/store-hooks";
import { showToast } from "../../../shared/global-tools/toast-system";
import Navbar from "../../parts/Navbar/Navbar";
import Spinner from "../../utils/Spinner/Spinner";
import StepBadge from "../../utils/StepBadge/StepBadge";
import CreateDatabaseStepOne from "./CreateDatabaseStepOne/CreateDatabaseStepOne";
import CreateDatabaseStepThree from "./CreateDatabaseStepThree/CreateDatabaseStepThree";
import CreateDatabaseStepTwo from "./CreateDatabaseStepTwo/CreateDatabaseStepTwo";
import "./DatabaseCreateScreen.scss";

export default function DatabaseEditScreen() {
  const { databaseId } = useParams();
  const formatedReferenceId = nbVal(databaseId);
  const { getDatabaseCreationInfo } = useGetDatabaseCreationInfo();
  const databaseCreationInfo = getDatabaseCreationInfo();
  const [step, setStep] = useState(1);
  const [stepTitle, setStepTitle] = useState("Configuration");
  const wrapAsync = useWrapAsync();
  const [loadingReference, setLoadingReference] = useState(false);
  const { referenceToEdit, setReferenceToEdit } = useAppStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (step === 1) {
      setStepTitle("Configuration");
      return;
    }
    if (step === 2) {
      setStepTitle("Tables et champs");
      return;
    }
    setStepTitle("Relations");
  }, [step]);

  useEffect(() => {
    if (!databaseCreationInfo) return;
    const fetchReference = wrapAsync(async () => {
      try {
        setLoadingReference(true);
        const res = await fetchOneReference(databaseCreationInfo.referenceId);
        setReferenceToEdit(res);
      } catch (error) {
        console.error("Error fetching reference:", error);
        showToast("Erreur lors de la récupération des informations", { severity: "error" });
        navigate(`app/databases/${formatedReferenceId}/view`);
      } finally {
        setLoadingReference(false);
      }
    });
    fetchReference();
  }, [databaseCreationInfo]);

  const stepOne = loadingReference ? (
    <Spinner />
  ) : (
    <CreateDatabaseStepOne navigateToStep={setStep} reference={referenceToEdit} />
  );
  let stepComponent = stepOne;
  if (step === 1) {
    stepComponent = stepOne;
  }
  if (step === 2) {
    stepComponent = <CreateDatabaseStepTwo navigateToStep={setStep} />;
  }
  if (step === 3) {
    stepComponent = (
      <CreateDatabaseStepThree navigateToStep={setStep} referenceId={formatedReferenceId} />
    );
  }

  if (!referenceToEdit) {
    return <Spinner />;
  }
  return (
    <div>
      <Navbar pageTitle={"Editer un référentiel complexe"} />

      <div className="DatabaseCreateScreen Container">
        <div className="Container-content">
          <div className="Stepper">
            <div className="Stepper-navWrapper">
              <ul className="Stepper-nav">
                <li className="Stepper-header">
                  <StepBadge value={1} active={step === 1} />{" "}
                  <span className={`Stepper-btnLabel ${step === 1 ? " active" : ""}`}>
                    Configuration
                  </span>
                </li>
                <li>
                  <div className="Stepper-divider" />{" "}
                </li>
                <li className="Stepper-header">
                  <StepBadge value={2} active={step === 2} />{" "}
                  <span className={`Stepper-btnLabel ${step === 2 ? " active" : ""}`}>
                    Tables et champs
                  </span>
                </li>
                <li>
                  <div className="Stepper-divider" />{" "}
                </li>
                <li className="Stepper-header">
                  <StepBadge value={3} active={step === 3} />{" "}
                  <span className={`Stepper-btnLabel ${step === 3 ? " active" : ""}`}>
                    Relations
                  </span>
                </li>
              </ul>

              <h2 className="Stepper-title">{stepTitle}</h2>
            </div>

            <div className="Stepper-body">{stepComponent}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
